import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { dispatcher } from 'dispatcher';
import { prop } from 'ramda';

import { JACKPOTS_REDUCER } from '@core/js/store/constants';
import { useCustomSelector, useUserSelector } from '@core/js/store/hooks';

import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { getGamesGlobalJackpots } from '@interlayer/js/components/common/Jackpot/buzz/server';
import * as actions from '@interlayer/js/components/common/Jackpot/store/actions.buzz';

import { GLOBAL_GAMES_JACKPOT_DEFAULT_PREFIX } from '../constants';
import { TJackpot } from '../types';

const requests: Set<string> = new Set();

export const useGetJackpot = (code: string, gamePayId?: number) => {
    const dispatch = useDispatch();
    const { jackpots: jackpotsData } = useCustomSelector(JACKPOTS_REDUCER);
    const currencyCode = useUserSelector(prop('currencyCode'));
    const hasJackpot = Boolean(jackpotsData[code]);
    const [
        dTagGamesGlobalJackpotUrl,
        dTagGamesGlobalJackpotPrefix = GLOBAL_GAMES_JACKPOT_DEFAULT_PREFIX
    ] = useDynamicTags([
        DYNAMIC_TAG_NAMES.gamesGlobalJackpotUrl,
        DYNAMIC_TAG_NAMES.gamesGlobalJackpotPrefix
    ]);

    useEffect(() => {
        if (dTagGamesGlobalJackpotUrl && gamePayId && !requests.has(code) && !hasJackpot) {
            requests.add(code);

            getGamesGlobalJackpots({
                dTagGamesGlobalJackpotUrl,
                currencyCode,
                moduleId: code
                    .replace(dTagGamesGlobalJackpotPrefix, '')
                    .replace(`_${gamePayId}`, '')
                    .trim()
            })
                .then((response) => {
                    const jackpots = response.filter((j: TJackpot) => j.gamePayId === gamePayId);

                    dispatch(actions.fetchGamesGlobalJackpot({ jackpots, prefix: dTagGamesGlobalJackpotPrefix, gamePayId }));

                    dispatcher.dispatch('jackpots:gamesGlobal', jackpots);

                    requests.delete(code);
                });
        }
    }, [code, currencyCode, dTagGamesGlobalJackpotPrefix, dTagGamesGlobalJackpotUrl, dispatch, gamePayId, hasJackpot]);
};
